
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/creator-dashboard",
      function () {
        return require("private-next-pages/creator-dashboard/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/creator-dashboard"])
      });
    }
  